/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {Fragment, useCallback, useMemo} from 'react';
import {Dimensions, Platform, View} from 'react-native';
import {connect} from 'react-redux';
import {addThousandSeparator} from '../../../../../common/utils/functions';
import {countBeneficiairesRapatriementByTrancheAge} from '../../../../../common/utils/rapatriement';
import {BREAKPOINT} from '../../../../../data/constants/screen';
import {ConnexionTitle} from '../../../../../data/constants/titles';
import {
  DevisRapatriementParam,
  DevisRapatriementResponse,
} from '../../../../../data/types/interface/Assurance/AssuranceRapatriement/devis';
import {StackParams} from '../../../../../data/types/navigation';
import {mapDispatchToProps} from '../../../../../services/redux/actions';
import mapStateToProps from '../../../../../services/redux/mapStateToProps';
import PrimaryButton from '../../../../components/Button/PrimaryButton';
import {buttonsStyles} from '../../../../components/Button/boutonStyle';
import {BoxShadowed} from '../../../../components/Container/BoxShadowed';
import Label from '../../../../components/Label';
import ConfirmationModal from '../../../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../../../components/PageContainer';
import {styles} from './styles';
interface ResultProps {
  data: DevisRapatriementResponse;
  beneficiaires: DevisRapatriementParam[];
  onCancel: () => void;
  user?: Record<string, any>;
}

interface ModalDataDTO {
  status: boolean;
  title: string;
  message: string;
  action: () => void;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  cancel: Function | undefined;
  button1Label: string;
  button2Label: string | undefined;
}
const initModalDatas: ModalDataDTO = {
  status: false,
  title: '',
  message: '',
  action: () => {},
  cancel: () => {},
  button1Label: '',
  button2Label: '',
};
type NavigationProps = StackNavigationProp<StackParams, 'DemanderDevis'>;

const ResultFC = ({data, beneficiaires, onCancel, user}: ResultProps) => {
  const {navigate} = useNavigation<NavigationProps>();

  const repartition = useMemo(() => {
    return countBeneficiairesRapatriementByTrancheAge(data.beneficiaires);
  }, [data]);

  const [modalDatas, setModalDatas] = React.useState<ModalDataDTO>({
    ...initModalDatas,
  });

  const showConnectionModal = useCallback(() => {
    setModalDatas({
      status: true,
      title: ConnexionTitle,
      message: '',
      action: () => {
        setModalDatas({...initModalDatas});
        navigate('Login', {
          data: 'SouscriptionAssuranceRapatriement',
          params: {
            beneficiaires,
          },
        });
      },
      cancel: () => setModalDatas({...initModalDatas}),
      button1Label: 'Connexion',
      button2Label: 'Annuler',
    });
  }, []);

  const handleSubscribe = useCallback(() => {
    user?.data?.utilisateur
      ? navigate('SouscriptionAssuranceRapatriement', {
          beneficiaires,
          dateDebut: new Date(),
        })
      : showConnectionModal();
  }, [user, beneficiaires]);

  const ResultButtons = () => {
    return (
      <View style={[styles.buttonContainer]}>
        <PrimaryButton
          onPress={() => onCancel()}
          styleBtnTxt={buttonsStyles.btnAnnuler}
          styleBtnOuter={[buttonsStyles.btnAnnulerOuterSimu, {maxWidth: 200}]}
          styleContainer={{alignItems: 'center'}}
          title="Refaire un devis"
          type="annuler"
        />
        <PrimaryButton
          onPress={handleSubscribe}
          styleBtnTxt={[styles.buttonText]}
          styleBtnOuter={[styles.buttonOuter, {maxWidth: 200}]}
          styleContainer={{alignItems: 'center'}}
          title={'Souscrire'}
          type="valider"
          isDisable={!Boolean(data)}
        />
      </View>
    );
  };

  return (
    <View style={styles.wholeContainer}>
      <Fragment>
        <PageContainer style={styles.container}>
          <Label
            title="Assurance obsèques à dago"
            textStyle={{textTransform: 'uppercase'}}
            type="mainTitle"
          />
          <Label title="Veuillez-trouver ci-après votre devis" />

          <BoxShadowed
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              paddingHorizontal:
                Dimensions.get('window').width < BREAKPOINT.sm ? 20 : 40,
            }}>
            <View>
              <Label
                title={`Répartition par tranche d'âges:`}
                textStyle={styles.lightGreenSubtitle}
              />
              {repartition.map(r => (
                <View
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    gap: 20,
                  }}
                  key={r.trancheAge}>
                  <Label
                    title={`${r.trancheAge} ans: `}
                    textStyle={{fontWeight: 700}}
                  />
                  <Label title={`${r.count}`} />
                </View>
              ))}
            </View>

            <View>
              <View style={[styles.flex, styles.priceContainer]}>
                <Label
                  title={`Prime TTC en Ariary: `}
                  type="mainTitle"
                  textStyle={styles.noMargin}
                />
                <Label
                  title={`${addThousandSeparator(
                    Math.ceil(data.tarificationTotale.primeTtcTotaleMGA),
                  )} Ar`}
                  type="mainTitle"
                  textStyle={styles.noMargin}
                />
              </View>

              <View style={[styles.flex, styles.priceContainer]}>
                <Label
                  title={`Prime TTC en Euro: `}
                  type="mainTitle"
                  textStyle={styles.noMargin}
                />
                <Label
                  title={`${addThousandSeparator(
                    Math.ceil(data.tarificationTotale.primeTtcTotaleEUR),
                  )} €`}
                  type="mainTitle"
                  textStyle={styles.noMargin}
                />
              </View>
            </View>

            <View>
              <Label
                title={`Garanties incluses`}
                textStyle={styles.lightGreenSubtitle}
              />
              {data.garanties.map(g => (
                <Label
                  title={`- ${g.type}${
                    g.couverture ? `: ${g.couverture}` : ''
                  }`}
                />
              ))}
            </View>
          </BoxShadowed>

          {Platform.OS === 'web' && (
            <View style={{alignItems: 'center'}}>
              <ResultButtons />
              {/* <View style={{height: 120}} /> */}
            </View>
          )}
          {Platform.OS !== 'web' && <ResultButtons />}
        </PageContainer>
      </Fragment>

      {modalDatas.status && (
        <ConfirmationModal
          title={modalDatas.title}
          content={modalDatas.message}
          btn1={modalDatas.button1Label}
          btn2={modalDatas.button2Label}
          handleBtn1={modalDatas.action}
          handleBtn2={modalDatas.cancel}
        />
      )}
    </View>
  );
};

export const Result = connect(mapStateToProps, mapDispatchToProps)(ResultFC);
